type Props = {
  children: React.ReactNode
}

export function CardBody({ children }: Props) {
  return (
    <dl className='divide-y divide-zinc-200 dark:divide-zinc-800 px-4 py-1 dark:text-zinc-400 text-sm'>
      {children}
    </dl>
  )
}